import { DataTable } from '@/components/ui/DataTable';
import { Badge } from '@/components/ui/Badge';
import type { AdminOrganisation } from '@/types/admin.types';
import { formatCurrency, formatDateTime } from '@/utils/formatters';
import { createColumnHelper } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

const columnHelper = createColumnHelper<AdminOrganisation>();

const columns = [
  columnHelper.accessor('name', {
    header: 'Organisation',
    cell: (info) => (
      <div>
        <p className="font-medium text-neutral-900 dark:text-neutral-200">{info.getValue()}</p>
        <p className="text-xs text-neutral-500">{info.row.original.slug}</p>
      </div>
    ),
  }),
  columnHelper.accessor('memberCount', {
    header: 'Membres',
    cell: (info) => <span className="text-neutral-600 dark:text-neutral-400">{info.getValue()}</span>,
  }),
  columnHelper.accessor('domainCount', {
    header: 'Domaines',
    cell: (info) => <span className="text-neutral-600 dark:text-neutral-400">{info.getValue()}</span>,
  }),
  columnHelper.accessor('plan', {
    header: 'Plan',
    cell: (info) => <Badge variant="info">{info.getValue() || 'Standard'}</Badge>,
  }),
  columnHelper.accessor('mrr', {
    header: 'MRR',
    cell: (info) => <span className="text-neutral-700 dark:text-neutral-300 font-medium">{formatCurrency(info.getValue())}</span>,
  }),
  columnHelper.accessor('status', {
    header: 'Statut',
    cell: (info) => {
      const v = info.getValue();
      return <Badge variant={v === 'active' ? 'success' : v === 'suspended' ? 'danger' : 'neutral'}>{v}</Badge>;
    },
  }),
  columnHelper.accessor('createdAt', {
    header: 'Création',
    cell: (info) => <span className="text-xs text-neutral-500">{formatDateTime(info.getValue())}</span>,
  }),
];

interface OrganisationsTableProps {
  data: AdminOrganisation[];
  loading?: boolean;
}

export function OrganisationsTable({ data, loading }: OrganisationsTableProps) {
  const navigate = useNavigate();
  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      onRowClick={(row) => navigate(`/organisations/${row.uuid}`)}
      emptyMessage="Aucune organisation trouvée"
    />
  );
}
